import { render } from "./Saffron.vue?vue&type=template&id=5edce496"
import script from "./Saffron.vue?vue&type=script&lang=js"
export * from "./Saffron.vue?vue&type=script&lang=js"

import "./Saffron.vue?vue&type=style&index=0&id=5edce496&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__